type DealProperty = {
  id: string;
  listed_by?: string | null;
  seller_user_id?: string | null;
  deleted_at?: string | null;
};

export function canCreateDealForProperty(property: DealProperty | null | undefined, userId: string | null | undefined) {
  if (!property || !userId || property.deleted_at) {
    return false;
  }

  return property.listed_by === userId || property.seller_user_id === userId;
}
